import React, { useEffect, useState } from "react";
import { Modal, Form, Button, Radio, message } from "antd";
import {
  LikeOutlined,
  DislikeOutlined,
  SafetyOutlined,
  ToolOutlined,
} from "@ant-design/icons";

import eventService from "../../../../services/eventService";
import { useUser } from "../../../../context/UserContext";

const INTENTION_OPTIONS = [
  { value: "Positivo", label: "Positivo", icon: <LikeOutlined />, color: "#7AC142" },
  { value: "Negativo", label: "Negativo", icon: <DislikeOutlined />, color: "#D4380D" },
  { value: "Preventivo", label: "Preventivo", icon: <SafetyOutlined />, color: "#1677FF" },
  { value: "Correctivo", label: "Correctivo", icon: <ToolOutlined />, color: "#D48806" },
];

export default function ModalIntencion({ open, setOpen, item, fetchData }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [intention, setIntention] = useState(item?.intention);
  const user = useUser();

  useEffect(() => {
    form.resetFields();
    setIntention(item?.intention);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // El PUT reemplaza el evento completo (mismo body que el POST de creación),
      // así que se reconstruye con los datos actuales del evento y solo se cambia la intención.
      const registro = {
        protocols: item?.protocols || [],
        type: item?.type,
        risk: item?.risk,
        causes: item?.causes || [],
        location: item?.location,
        title: item?.title,
        impact: item?.impact,
        date: item?.date,
        userId: item?.createdBy,
        source: item?.source,
        team: item?.team,
        intention: values.intention,
      };

      await eventService.actualizarEventoInicial(
        item.id,
        registro,
        user.idToken
      );
      message.success("Intención guardada");
      setOpen(false);
      fetchData();
    } catch (error) {
      console.error("Error al guardar la intención:", error);
      message.error("No se logró guardar la intención");
    }
    setLoading(false);
  };

  return (
    <Modal
      title={`Añadir intención - ${item?.id || ""}`}
      open={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ intention: item?.intention }}
        validateMessages={{ required: "Es requerido" }}
      >
        <Form.Item
          name="intention"
          label="Intención del evento"
          rules={[{ required: true, message: "Selecciona una intención" }]}
        >
          <Radio.Group
            value={intention}
            onChange={(e) => setIntention(e.target.value)}
            style={{ width: "100%", display: "flex", flexWrap: "wrap", gap: 8 }}
          >
            {INTENTION_OPTIONS.map((option) => (
              <Radio.Button
                key={option.value}
                value={option.value}
                style={{
                  flex: "1 1 45%",
                  textAlign: "center",
                  borderColor:
                    intention === option.value ? option.color : undefined,
                  color: intention === option.value ? option.color : undefined,
                }}
              >
                {option.icon} {option.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>

        <Button type="primary" htmlType="submit" block loading={loading}>
          Guardar
        </Button>
      </Form>
    </Modal>
  );
}
